module.exports = __webpack_public_path__ + "media/src/images/icons/underline-a9897f49a49e3c58a59dcc6bf7b833e6.svg";